// Modules disponibles
export const MODULES = {
  SUBSCRIBERS: 'subscribers',
  METERS: 'meters',
  READINGS: 'readings',
  BILLING: 'billing',
  PAYMENTS: 'payments',
  REPORTS: 'reports'
};

export const MODULE_LABELS = {
  subscribers: 'Abonnés',
  meters: 'Compteurs',
  readings: 'Relevés',
  billing: 'Facturation',
  payments: 'Paiements',
  reports: 'Rapports'
};

// Permissions par défaut selon le rôle
export const getDefaultPermissions = (role) => {
  const allModules = Object.values(MODULES);
  
  if (role === 'admin') {
    // Admins ont accès à tout
    return allModules.reduce((acc, module) => {
      acc[module] = true;
      return acc;
    }, {});
  }
  
  if (role === 'operator') {
    // Opérateurs ont accès à tout par défaut
    return allModules.reduce((acc, module) => {
      acc[module] = true;
      return acc;
    }, {});
  }
  
  if (role === 'viewer') {
    // Viewers n'ont accès à rien par défaut (mais peut être configuré par l'admin)
    return allModules.reduce((acc, module) => {
      acc[module] = false;
      return acc;
    }, {});
  }
  
  return {};
};

// Fonction pour vérifier l'accès à un module
export const hasAccessToModule = (permissions, module) => {
  if (!permissions) return false;
  return permissions[module] === true;
};

// Fonction pour mettre à jour une permission
export const updatePermission = (permissions, module, hasAccess) => {
  return {
    ...permissions,
    [module]: hasAccess
  };
};

// Fonction pour obtenir tous les modules accessibles
export const getAccessibleModules = (permissions) => {
  return Object.keys(MODULES)
    .filter(key => permissions[MODULES[key]] === true)
    .map(key => MODULES[key]);
};
